export const CREATE_INTEGRATION_TOKEN_REQUEST = '@integration/CREATE_INTEGRATION_TOKEN_REQUEST';
export const CREATE_INTEGRATION_TOKEN_SUCCESS = '@integration/CREATE_INTEGRATION_TOKEN_SUCCESS';
export const CREATE_INTEGRATION_TOKEN_FAILURE = '@integration/CREATE_INTEGRATION_TOKEN_FAILURE';
export const RETRIEVE_INTEGRATION_TOKEN_REQUEST = '@integration/RETRIEVE_INTEGRATION_TOKEN_REQUEST';
export const RETRIEVE_INTEGRATION_TOKEN_SUCCESS = '@integration/RETRIEVE_INTEGRATION_TOKEN_SUCCESS';
export const RETRIEVE_INTEGRATION_TOKEN_FAILURE = '@integration/RETRIEVE_INTEGRATION_TOKEN_FAILURE';
